import { css } from '@emotion/react'
import styled from '@emotion/styled'

interface IWrapperStyles {
  marginTop?: number
}

export const Wrapper = styled.span(
  ({ marginTop = 0 }: IWrapperStyles) => css`
    display: inline-flex;
    align-items: center;
    margin-top: ${marginTop}px;

    svg {
      padding: 0 0.2em;
      width: 16px;
    }
    span {
      margin-left: 0.2em;
    }
  `
)
